// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { DatePickerTokens } from './type';

const datePickerTokens: DatePickerTokens = {
  datePickerFontSize: 'Font-14',
  datePickerFontColor: 'Neutral-text-5',
  datePickerBorderRadius: 'Radius-default',
  datePickerBorderColor: 'Neutral-border-2',
  datePickerPaddingX: 'Spacing-8',
  datePickerPaddingY: 'Spacing-4',
  datePickerIconSize: 'Font-14',
  datePickerIconColor: 'Neutral-text-4',
  datePickerSmallIconSize: 'Font-12',
  datePickerSmallPanelFooterNowPaddingX: 'Spacing-16',
  datePickerSmallPanelFooterNowPaddingY: 'Spacing-11',
  datePickerSmallFontSize: 'Font-12',
  datePickerSmallPaddingX: 'Spacing-8',
  datePickerSmallPaddingY: 'Spacing-1',
  datePickerLargeIconSize: 'Font-16',
  datePickerLargeFontSize: 'Font-16',
  datePickerLargePaddingX: 'Spacing-12',
  datePickerLargePaddingY: 'Spacing-7',
  datePickerPlaceholderColor: 'Neutral-text-2',
  datePickerBackgroundColor: 'Neutral-fill-1',
  datePickerClearColor: 'Neutral-text-3',
  datePickerHoverBorderColor: 'Brand-6',
  datePickerHoverClearColor: 'Neutral-text-4',
  datePickerFocusBorderColor: 'Brand-7',
  datePickerFocusShadow: 'Brand-2',
  datePickerDisabledFontColor: 'Neutral-text-2',
  datePickerDisabledPlaceholderColor: 'Neutral-text-2',
  datePickerDisabledBorderColor: 'Neutral-border-1',
  datePickerDisabledBackgroundColor: 'Neutral-fill-2',
  datePickerResultTextBorderRadius: 'Radius-default',
  datePickerResultTextPaddingX: 'Spacing-4',
  datePickerResultTextSmallPaddingX: 'Spacing-4',
  datePickerResultTextLargePaddingX: 'Spacing-10',
  datePickerResultTextActiveBackgroundColor: 'Brand-1',
  datePickerErrorBorderColor: 'Danger-6',
  datePickerErrorFocusShadow: 'Danger-1',
  datePickerPanelTitlePaddingTop: 'Spacing-10',
  datePickerPanelTitleFontSize: 'Font-14',
  datePickerPanelColor: 'Neutral-text-5',
  datePickerPanelFontWeight: 'Weight-regular',
  datePickerPanelBackgroundColor: 'Neutral-fill-1',
  datePickerPanelShadow: 'Shadow-2',
  datePickerPanelRadius: 'Radius-default',
  datePickerPanelMargin: 'Spacing-24',
  datePickerPanelBorder: 'Neutral-border-1',
  datePickerPanelHeaderFontSize: 'Font-14',
  datePickerPanelHeaderFontColor: 'Neutral-text-5',
  datePickerPanelHeaderFontWeight: 'Weight-medium',
  datePickerPanelHeaderPaddingX: 'Spacing-12',
  datePickerPanelHeaderPaddingY: 'Spacing-8',
  datePickerPanelHeaderBorderColor: 'Neutral-border-1',
  datePickerPanelHeaderIconColor: 'Neutral-text-4',
  datePickerPanelHeaderIconWidth: 'Font-14',
  datePickerPanelHeaderIconHotWidth: 'Size-13',
  datePickerPanelHeaderIconHoverBackgroundColor: 'Neutral-fill-3',
  datePickerPanelHeaderTitlePaddingX: 'Spacing-4',
  datePickerPanelBodyPaddingX: 'Spacing-16',
  datePickerPanelBodyPaddingY: 'Spacing-16',
  datePickerPanelBodyFontSize: 'Font-14',
  datePickerPanelFooterPaddingX: 'Spacing-16',
  datePickerPanelFooterPaddingY: 'Spacing-10',
  datePickerPanelFooterLeftFontSize: 'Font-14',
  datePickerPanelFooterRightFontSize: 'Font-14',
  datePickerCellColor: 'Neutral-text-5',
  datePickerCellHotHeight: 'Size-12',
  datePickerCellHeight: 'Size-16',
  datePickerCellHoverColor: 'Neutral-text-5',
  datePickerCellHoverBackgroundColor: 'Neutral-fill-3',
  datePickerCellActiveColor: 'Neutral-text-1',
  datePickerCellActiveBackgroundColor: 'Brand-6',
  datePickerCellActiveHoverBackgroundColor: 'Brand-2',
  datePickerCellDisabledColor: 'Neutral-text-2',
  datePickerCellDisabledBackgroundColor: 'Neutral-fill-2',
  datePickerCellRangeBackgroundColor: 'Brand-1',
  datePickerCellOtherColor: 'Neutral-text-2',
  datePickerCellHeaderColor: 'Neutral-text-4',
  datePickerCellMarginY: 'Spacing-4',
  datePickerTimePanelPaddingX: 'Spacing-12',
  datePickerTimePanelPaddingY: 'Spacing-6',
  datePickerTimeListGap: 'Spacing-8',
  datePickerTimeItemHeight: 'Size-15',
  datePickerTimeItemBorderRadius: 'Radius-default',
  datePickerTimeItemPaddingY: '2px',
  datePickerTimeItemBackgroundColor: 'Neutral-fill-1',
  datePickerTimeItemColor: 'Neutral-text-5',
  datePickerTimeItemActiveBackgroundColor: 'Brand-1',
  datePickerTimeItemActiveColor: 'Brand-6',
  datePickerTimeItemDisabledColor: 'Neutral-text-2',
  datePickerTimeItemHoverBackgroundColor: 'Neutral-fill-2',
  datePickerQuickPanelPaddingX: 'Spacing-8',
  datePickerQuickPanelPaddingY: 'Spacing-12',
  datePickerQuickPanelGap: 'Spacing-8',
  datePickerQuickPanelItemFontSize: 'Font-12',
  datePickerQuickPanelItemPaddingX: 'Spacing-12',
  datePickerQuickPanelItemPaddingY: 'Spacing-2',
  datePickerQuickPanelItemActiveBackgroundColor: 'Brand-1',
  datePickerQuickPanelItemActiveFontColor: 'Brand-6',
  datePickerQuickPanelItemHoverBackgroundColor: 'Neutral-fill-2',
};

export default datePickerTokens;
